// Agent configuration types and data
export interface SocialLinks {
  facebook?: string;
  instagram?: string;
  linkedin?: string;
  zillow?: string;
  retter: string;
}

export interface AgentConfig {
  name: string;
  title: string;
  email: string;
  phone: string;
  office: {
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
  };
  imageUrl: string;
  heroDescription: string;
  aboutDescription: string;
  socialLinks: SocialLinks;
  toolboxUrl?: string;
}

export const agent: AgentConfig = {
  name: "Monroe Davis",
  title: "Real Estate Agent",
  email: "monroe@rcsothebysrealty.com",
  phone: "(509) 528-2178",
  office: {
    address: "329 North Kellogg St.",
    city: "Kennewick",
    state: "WA",
    zip: "99336",
    country: "United States"
  },
  imageUrl: "/monroe-davis (ACC#0F4695).webp",
  heroDescription: "I'm dedicated to turning your home search into an effortless, empowering and joyous journey.",
  aboutDescription: `Welcome to Homes by Monroe Davis, your trusted partner in the exciting journey of buying or selling your home. With over 20 years of experience in the real estate industry, 7 with Retter & Company Sotheby's International Realty, I've built a sterling reputation by providing peace of mind to clients in many aspects of their real estate needs.

At the core of my approach are my clients. I comprehend that buying or selling a home is not merely a transaction, but a significant life event. My commitment is to meticulously take care of every detail, whether you're buying your dream home or selling your cherished property, allowing you to focus on the thrilling next chapter of your life.

My passion spans across both ends of the real estate spectrum. From helping clients discover their perfect homes to strategizing successful and profitable home sales, my background as a finishing contractor enables me to bring a discerning eye for quality to every real estate journey. This ensures you receive nothing but the best service, whether you're a buyer or a seller. My dedication to my clients and my craft is unwavering, resulting in win-win scenarios and sincere satisfaction.

Above all, my primary goal is to deliver peace of mind. I handle the stress and any complications that may arise, guaranteeing a calm, smooth process for you. After all, you deserve more than just a home or a sale – you deserve an extraordinary real estate experience.

When I'm not transforming real estate dreams into reality, I dedicate my time to my family and coaching football and basketball for my two sons. Always open to exploration, I love the outdoors and the remarkable trails and rivers our area has to offer.

Join me on this remarkable journey to buy or sell your home, and experience the exceptional care and expertise I bring to every transaction.`,
  socialLinks: {
    facebook: "https://www.facebook.com/monroeyd",
    instagram: "https://www.instagram.com/monroeyd/",
    linkedin: "https://www.linkedin.com/in/monroe-davis-62392a149/",
    zillow: "https://www.zillow.com/profile/monroe507",
    retter: "https://www.rcsothebysrealty.com/agents/monroe-davis"
  },
  toolboxUrl: "https://md.retterco.com/home"
};